import React from 'react';
import { Outlet } from 'react-router-dom';

const RouterOutlet: React.FC = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

const AuthOutlet: React.FC = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export { RouterOutlet, AuthOutlet };
